import Contract from '@/models/contract'
import { isMarketSingle } from '@/utils/helpers'

export default {
  props: {
    market: {},
    contract: {},
  },
  computed: {
    isMarketSingle() {
      return isMarketSingle(this.market);
    },
    contractModel() {
      return this.contract ? new Contract(this.contract) : {};
    },
    imageUrl() {
      return this.contractModel.contractImageSmallUrl || this.contractModel.contractImageUrl;
    },
    contractImageStyleModifiers() {
      return {
        'background-image': `url(${this.imageUrl})`,
      };
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/purchase-extended-betslip-contract-info/purchase-extended-betslip-contract-info.js